
import { cva } from "class-variance-authority"

import logo from "url:../images/logo.svg";

const logoVariants = cva(

  "w-[66px] h-[66px] mx-auto sm:w-[124px] sm:h-[124px] transition-[width,height] duration-300",

  {

    variants: {

      variant: {

        footer: "-mb-[22px] sm:-mb-[40px]",

        header: "-mb-[58px] sm:-mb-[62px]",

      },

    }

  }

);

export function Logo( { variant } ) {

  return (

    <img 
          
      alt="bioMérieux logo" 
    
      className={ logoVariants( { variant } ) }

      src={ logo } 
      
    />

  );

}
